document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ca-nightmare-demo]').forEach((root) => {
    const data = JSON.parse(root.querySelector('[data-ca-products]').textContent);
    const panels = [...root.querySelectorAll('[data-ca-panel]')];
    const galleryButtons = [...root.querySelectorAll('[data-ca-gallery-button]')];

    const showPanel = (index) => {
      const panelIndex = String(index);
      panels.forEach((panel) => {
        const selected = panel.dataset.caPanel === panelIndex;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
      galleryButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.caGalleryButton === panelIndex));
    };

    galleryButtons.forEach((button) => button.addEventListener('click', () => {
      showPanel(button.dataset.caGalleryButton);
    }));

    root.querySelectorAll('[data-ca-video-play]').forEach((button) => button.addEventListener('click', () => {
      const video = button.parentElement.querySelector('video');
      video.controls = true;
      video.play();
      button.hidden = true;
    }));

    const form = root.querySelector('.ca-demo-form');
    const variant = root.querySelector('[data-ca-variant]');
    const price = root.querySelector('[data-ca-price]');
    const copy = root.querySelector('[data-ca-offer-copy]');
    const delivery = root.querySelector('[data-ca-delivery]');
    const add = root.querySelector('[data-ca-add]');
    const formatInputs = [...root.querySelectorAll('input[name="ca-format"]')];
    const offerInputs = [...root.querySelectorAll('input[name="ca-print-offer"]')];
    const printOffers = root.querySelector('[data-ca-print-offers]');
    const audioOffers = root.querySelector('[data-ca-audio-offers]');
    const money = new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency });

    const selectedItems = () => {
      const formats = new Set(formatInputs.filter((input) => input.checked).map((input) => input.value));
      const offer = root.querySelector('input[name="ca-print-offer"]:checked')?.value || 'single';
      const items = [];
      if (formats.has('paperback')) items.push(data[offer === 'bundle' ? 'bundle' : 'paperback']);
      if (formats.has('audio')) items.push(data.audio);
      return items;
    };

    const render = () => {
      const formats = new Set(formatInputs.filter((input) => input.checked).map((input) => input.value));
      formatInputs.forEach((input) => input.closest('label').classList.toggle('is-selected', input.checked));
      offerInputs.forEach((input) => input.closest('label').classList.toggle('is-selected', input.checked));
      if (printOffers) printOffers.hidden = !formats.has('paperback');
      if (audioOffers) audioOffers.hidden = !formats.has('audio');
      const items = selectedItems();
      if (!items.length) {
        variant.value = '';
        price.textContent = 'Select an edition';
        copy.textContent = 'Choose the paperback, the audiobook, or both.';
        delivery.textContent = '';
        add.textContent = 'Choose an edition';
        add.disabled = true;
        return;
      }

      variant.value = items[0].id;
      add.disabled = false;
      if (items.length === 1) {
        const item = items[0];
        price.innerHTML = `${item.price} <small>${data.currency}</small>`;
        copy.textContent = item.copy;
        delivery.textContent = `▣  ${item.delivery}`;
        add.textContent = item.button;
        return;
      }

      const total = items.reduce((sum, item) => sum + Number(item.priceCents), 0);
      price.innerHTML = `${money.format(total / 100)} <small>${data.currency}</small>`;
      copy.textContent = `${items[0].copy} ${items[1].copy}`;
      delivery.textContent = '▣  Physical book + digital audiobook';
      add.textContent = 'Add both editions to your bag';
    };

    formatInputs.forEach((input) => input.addEventListener('change', () => {
      render();
      if (input.checked && input.value === 'audio') showPanel(2);
      if (input.checked && input.value === 'paperback') showPanel(0);
      if (!input.checked && input.value === 'audio' && root.querySelector('input[name="ca-format"][value="paperback"]').checked) showPanel(0);
      if (!input.checked && input.value === 'paperback' && root.querySelector('input[name="ca-format"][value="audio"]').checked) showPanel(2);
    }));
    offerInputs.forEach((input) => input.addEventListener('change', () => {
      root.querySelector('input[name="ca-format"][value="paperback"]').checked = true;
      render();
      showPanel(input.value === 'bundle' ? 3 : 0);
    }));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const items = selectedItems();
      if (!items.length) return;
      const oldText = add.textContent;
      add.disabled = true;
      add.textContent = items.length > 1 ? 'Adding both editions…' : 'Adding to your bag…';
      try {
        const response = await fetch(data.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map((item) => ({ id: Number(item.id), quantity: 1 })) }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.assign(data.cartUrl);
      } catch (error) {
        add.disabled = false;
        add.textContent = oldText;
        copy.textContent = 'Something went wrong adding those editions. Please try again.';
      }
    });

    render();
  });
});
